import {
  EventNoteNotificationIcon,
  EditNotificationIcon,
  DeleteNotificationIcon,
  EventNoteCanselNotificationIcon,
  UnSaveNotificationIcon,
  OkNotificationIcon
} from '@/constants/icon'

export const NEW_LEAVE_REQUESTED = 1
export const NEW_LEAVE_REQUESTED_EDITED = 2
export const NEW_LEAVE_REQUESTED_DELETED = 3
export const WITHDRAWAL_REQUESTED = 4

export const NOTIFICATION_HR = [
  {
    id: NEW_LEAVE_REQUESTED,
    name: 'New Leave Requested',
    desc: 'requested',
    icon: EventNoteNotificationIcon,
    class: 'background-green',
    router: {
      name: 'EmployeesCard-HR',
      nameRouteChildren: 'time-off-balance-HR'
    }
  },
  {
    id: NEW_LEAVE_REQUESTED_EDITED,
    name: 'New Leave Request Edited',
    desc: 'edit',
    icon: EditNotificationIcon,
    class: 'background-blue'
  },
  {
    id: NEW_LEAVE_REQUESTED_DELETED,
    name: 'New Leave Request Deleted',
    desc: 'deleted',
    icon: DeleteNotificationIcon,
    class: 'background-red'
  },
  {
    id: WITHDRAWAL_REQUESTED,
    name: 'Withdrawal Requested',
    desc: 'requested a withdrawal of',
    icon: EventNoteCanselNotificationIcon,
    class: 'background-red',
    router: {
      name: 'EmployeesCard-HR',
      nameRouteChildren: 'time-off-balance-HR'
    }
  }
]

export const LEAVE_REQUESTED_APPROVED = 5
export const LEAVE_REQUESTED_MODIFIED = 6
export const LEAVE_REQUESTED_REJECTED = 7
export const LEAVE_REQUESTED_DELETED = 8

export const NOTIFICATION_EMPLOYEE = [
  {
    id: LEAVE_REQUESTED_APPROVED,
    name: 'Leave Request Approved',
    descFirst: 'Your request for',
    desc: 'has been approved by HR on',
    icon: OkNotificationIcon,
    class: 'background-green'
  },
  {
    id: LEAVE_REQUESTED_MODIFIED,
    name: 'Leave Request Modified',
    descFirst: 'Your request for',
    desc: 'has been modified by HR on',
    icon: EditNotificationIcon,
    class: 'background-blue',
    router: {
      name: 'EmployeesCard',
      nameRouteChildren: 'time-off-balance'
    }
  },
  {
    id: LEAVE_REQUESTED_REJECTED,
    name: 'Leave Request Rejected',
    descFirst: 'Your request for',
    desc: 'has been rejected by HR on',
    icon: UnSaveNotificationIcon,
    class: 'background-red',
    router: {
      name: 'EmployeesCard',
      nameRouteChildren: 'time-off-balance'
    }
  },
  {
    id: LEAVE_REQUESTED_DELETED,
    name: 'Approved Leave Request Deleted',
    descFirst: 'Your approved',
    desc: 'request has been deleted by HR on',
    icon: DeleteNotificationIcon,
    class: 'background-red',
    router: {
      name: 'EmployeesCard',
      nameRouteChildren: 'time-off-balance'
    }
  }
]

export const NOTIFICATION_ALL_HR = [...NOTIFICATION_HR, ...NOTIFICATION_EMPLOYEE]



// WEBPACK FOOTER //
// ./src/constants/notificationHr.js